import RecommenderCard from '@jo-v1/features/JoRecommender/ProgramSelect/RecommenderCard';
import StepsTracker from '@jo-v1/features/JoRecommender/ProgramSelect/StepsTracker';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { selectDcsDegrees, selectDcsSubjects } from '@core/reducers/dcsSlice';
import { selectAllInputs } from '@core/reducers/inputsSlice';
import type { VoyagerResult } from '@core/ts/results';

import styles from './JoEmbeddedRecommender.module.css';

type Props = {
  results: VoyagerResult[];
  eventingOverrides: { [key: string]: any };
};

const JoEmbeddedRecommender: FC<Props> = ({ results, eventingOverrides }) => {
  const degree = useSelector(selectDcsDegrees)[0];
  const subject = useSelector(selectDcsSubjects)[0];

  // inputs state properties
  const inputs = useSelector(selectAllInputs);

  if (!results || results.length === 0) {
    return null;
  }

  return (
    <section className={styles.joEmbeddedRecommender}>
      <div className={styles.content}>
        <header>
          <h2 className={styles.title}>
            {`Your ${degree} in ${subject} is Waiting${
              inputs?.firstName?.value ? `, ${inputs?.firstName?.value}` : ''
            }!`}
          </h2>
          <p className={styles.subtitle}>
            These schools are accepting students right now. Explore your matches and connect with a great program today.
          </p>
        </header>

        <div id="recommender_results" className={styles.cards}>
          {results?.map((result: any, index: number) => (
            <RecommenderCard
              withImage
              onRecommender={false}
              index={index}
              key={`${result.program.id}-${index}`}
              position={index + 1}
              result={result}
              eventingOverrides={{
                formatSubtype: 'jo-grid',
                customDimensions: [
                  { key: 'isUserRequested', value: 'true' },
                  ...(eventingOverrides.customDimensions || []),
                ],
              }}
            />
          ))}
          <StepsTracker stepsChecked={1} importantFactors={inputs?.importantFactors} />
        </div>
      </div>
    </section>
  );
};

export default JoEmbeddedRecommender;
